var React = require('react');

function MoreInfoBlackInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 0C0.802218 0 0.608879 0.0586494 0.44443 0.168531C0.27998 0.278412 0.151808 0.434591 0.0761205 0.617317C0.000432814 0.800043 -0.0193699 1.00111 0.0192153 1.19509C0.0578006 1.38907 0.153039 1.56725 0.292892 1.70711C0.432745 1.84696 0.610927 1.9422 0.804908 1.98079C0.99889 2.01937 1.19996 1.99957 1.38268 1.92388C1.56541 1.84819 1.72159 1.72002 1.83147 1.55557C1.94135 1.39112 2 1.19778 2 1C2 0.734783 1.89464 0.48043 1.70711 0.292894C1.51957 0.105357 1.26522 0 1 0Z","fill":"black","key":0}),React.createElement("rect",{"y":"2.99976","width":"2","height":"6","rx":"1","fill":"black","key":1})]);
}

MoreInfoBlackInline.defaultProps = {"width":"2","height":"9","viewBox":"0 0 2 9","fill":"none"};

module.exports = MoreInfoBlackInline;

MoreInfoBlackInline.default = MoreInfoBlackInline;
